import { name, version } from '../../package.json';

const release = `${name}@${version}`;

export const environment = {
  name,
  version,
  release,
  environment: 'production',
  isProduction: true,
  sentryDsn: 'https://a3dda922da0a463cbec981917243bdd8@o171479.ingest.sentry.io/1742247',
  apiUrl: '/srfh/api/sms/order',
  isDocker: false,
  gaTrackingId: 'UA-148942095-1'
};
